import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import "./Support.css";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import Tooltip from "@mui/material/Tooltip";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Grid2 } from "@mui/material";
import { Container } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAllTicketList, updateTicketData } from "../../Actions/SupportAction";
import { getTimeAgo } from "../../Helper/helper";
import { closeTicket } from "../../Services/support";
import { ToastError, ToastSuccess } from "../../CustomToaster/CustomToaster";
import TicketCardSkeleton from "../Skeleton/TicketCardSkeleton";


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  borderRadius: "10px",
  boxShadow: 24,
  padding: "20px"
};
const Support = () => {
  const [openCloseTicket, setOpenCloseTicket] = React.useState(false);
  const handleOpenCloseTicket = () => setOpenCloseTicket(true);
  const handleCloseCloseTicket = () => setOpenCloseTicket(false);

  //custom code
  const dispatch = useDispatch();
  const { ticketLoading, ticketData, ticketError, ticketStatus } = useSelector(
    (state) => state.support
  );
  const navigate = useNavigate();

  const [allTickets, setAllTickets] = useState([]);

  const hasFetched = useRef(false);
  const [ticketId, setTicketId] = useState(null)


  useEffect(() => {
    if (!ticketData && !hasFetched.current) {
      // const data = {
      //   page: currentPage,
      // };
      dispatch(getAllTicketList());
      hasFetched.current = true;
    }
  }, [ticketData, dispatch]);

  useEffect(() => {
    if (ticketStatus === true) {
      setAllTickets(ticketData?.result?.details);
      // setTotalPages(ticketData.result?.totalPages);
    } else {
    }
  }, [ticketStatus]);

  const [loading, setLoading] = useState(false)

  const handleCloseTicket = async () => {
    const data = {
      'ticketId': ticketId
    }
    setLoading(true)
    const response = await closeTicket(data);
    if (response?.data?.success) {
      ToastSuccess({ message: response?.data?.message, icon: false })
      setLoading(false);
      dispatch(updateTicketData({
        ticketId: ticketId,
        status: 'close',
        closedBy: 'user'
      }))
      setAllTickets((prev) =>
        prev.map((ticket) =>
          ticket.ticketId === ticketId
            ? {
              ...ticket,
              status: "close",
              closedBy: "user"
            }
            : ticket
        )
      );
      handleCloseCloseTicket();

    }
    else {
      ToastError({ message: response?.data?.message, icon: false })
      setLoading(false)

    }

  }


  return (
    <div className="support-page">
      <Container className="xl-box" maxWidth="xl">
        <Grid2 container sx={{ justifyContent: "center", alignItems: "center", marginBottom: "30px" }} className="container-support">
          <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <div className="display-2 mb-10" >
              <h2 className="gold-color">Support And Ticket</h2>
              <div className="text-end common-btn">
                <Link to="/create-ticket">
                  <div className="blu-btn " >
                    <Button startIcon={<AddRoundedIcon sx={{ color: "#000" }} />} className=""> New Ticket</Button>
                  </div>
                </Link>
              </div>
            </div> </Grid2>
          <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>


            {
              ticketLoading ?
                <div className="card-box mt-20">


                  <TicketCardSkeleton />
                </div>
                :
                (allTickets?.length > 0 ?
                  allTickets?.map((item, index) => (
                    <>
                      <div className="card-box mt-20" onClick={() => { navigate('/support2', { state: { item: item } }) }}>
                        <div className="ticket-header display-2">
                          <div className="ticket-id">
                            <Link className="display-1 gold-color">
                              <svg className="bn-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                <path d="M64 64C28.7 64 0 92.7 0 128l0 64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-64c0-35.3-28.7-64-64-64L64 64zm64 112l0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-320 0c-17.7 0-32-14.3-32-32l0-192z" />
                              </svg>
                              Ticket ID :<span>#{item?.ticketId}</span>
                            </Link>
                          </div>

                          <div
                            class="ticket-time display-1"
                            style={{
                              gap: "15px",
                            }}
                          >
                            <div className="ticke-status">
                              {
                                item?.status != "close" ?

                                  <Button
                                    startIcon={<HighlightOffRoundedIcon />}
                                    onClick={(e) => { e.stopPropagation(); handleOpenCloseTicket(); setTicketId(item?.ticketId) }}
                                  >
                                    Close Ticket
                                  </Button>
                                  :
                                  <p className="text-red">{`Ticket Closed by ${item?.closedBy === "user" ? "You" : "Admin"}`} </p>
                              }
                            </div>
                            <div className="time-zone">
                              <Tooltip title={item?.createdAt} placement="top">
                                <p className="display-1">
                                  <AccessTimeRoundedIcon />
                                  <span>{getTimeAgo(item?.createdAt)}</span>
                                </p>
                              </Tooltip>
                            </div>
                          </div>
                        </div>

                        <div className="ticket-body">
                          <Link>
                            <h4>{item?.title}</h4>
                            <h5>{item?.description}</h5>
                          </Link>
                          {/* <Link>Read More</Link> */}
                          <div class="tage-box mt-20">
                            <span>{item?.category}</span>
                            {/* <span>DASH - Dash</span> */}
                            {
                              item?.values?.map((data, ind) => {
                                return (
                                  Object.entries(data).map(([key, value]) => (
                                    <span key={key}>{key} - {value}</span>
                                  ))
                                )



                              })
                            }
                          </div>
                        </div>
                      </div>
                    </>

                  ))
                  :
                  <div className="card-box new  text-center mt-30">
                    <p>You haven't add ticket</p>
                    <p>
                      Click <Link to="/create-ticket"><span className="clr-span">+ New Ticket </span></Link>button to add
                      new ticket
                    </p>
                  </div>
                )
            }
          </Grid2>
        </Grid2>
      </Container>


      <div className="modal-popup2">
        <Modal
          open={openCloseTicket}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="common-modal-box cnl-support" style={style}>
            <div
              className="display-2"
              style={{
                borderBottom: "1px solid #0f50ad14",
                paddingBottom: "5px",
              }}
            >
              <h2
                id="modal-modal-title"

                style={{
                  fontWeight: "700",
                  fontSize: "1.25rem",
                }}
              >
                Confirmation
              </h2>
              <div className="close-icons-popup">
                <CloseRoundedIcon
                  onClick={() => { loading === false && handleCloseCloseTicket() }}

                  sx={{ cursor: "pointer", fontSize: "20px !important" }}
                />
              </div>
            </div>

            <p
              id="modal-modal-title"
              style={{
                textAlign: "left",
                fontSize: "18px",
                margin: "10px",
              }}
            >
              Are you sure you want Close this ticket ?
            </p>
            <div className="display-3">
              <div className="blu-btn mt-10">
                {
                  loading === true ?
                    <Button
                      disabled
                    >
                      Progressing
                    </Button>
                    :
                    <Button
                      onClick={() => handleCloseTicket()}
                    >
                      Confirm
                    </Button>
                }
              </div>
              <div className="blu-bdr mt-10">
                <Button
                  sx={{

                  }}
                  onClick={handleCloseCloseTicket}
                  disabled={loading === true}
                >
                  Cancel
                </Button>
              </div>
            </div>

          </Box>
        </Modal>
      </div>
    </div>
  );
};

export default Support;
